export * from './app-sidenav-nav.component';



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/components/app-sidenav-nav/index.ts